import { publicAxiosInstance } from '../../utils/axios';
import { MvpPartner } from '../types/mvpPartners';

export const mvpPartnersService = {
  // Keep the existing method that filters accounts
  getMvpPartners: async (): Promise<MvpPartner[]> => {
    const response = await publicAxiosInstance.get('/api/v1/accounts');
    return response.data.filter((account: MvpPartner) => account.isMvpPartner);
  },

  // New method that uses the dedicated endpoint
  getMvpPartnersFromDedicatedEndpoint: async (): Promise<MvpPartner[]> => {
    const response = await publicAxiosInstance.get('/api/v1/accounts/mvp-partners');
    return response.data;
  }
};
